"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Region", {
  enumerable: true,
  get: function get() {
    return _types.Region;
  }
});
Object.defineProperty(exports, "FiConnectEventTypes", {
  enumerable: true,
  get: function get() {
    return _types.FiConnectEventTypes;
  }
});
exports.default = exports.AppProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _emotionTheming = require("emotion-theming");

var _basis = require("basis");

var _context = require("./context");

var _types = require("./types");

var _env = require("./env.config");

var _theme = require("./theme");

var s = _interopRequireWildcard(require("./App.styles"));

var _Router = require("./Router");

var _utils = require("./utils");

var _components = require("./components");

var _useDatadog = require("./hooks/useDatadog");

var _ErrorBoundary = require("./components/error-boundary/ErrorBoundary");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// TODO: Keep context and types imports relative so that types work in consuming Host Apps - https://di.latitudefinancial.com/jira/browse/NZP-530
var AppProvider = function AppProvider(props) {
  var config = props.config,
      children = props.children;
  var hasBasisProvider = !!(0, _basis.useTheme)();
  var theme = (0, _theme.getTheme)(config.theme);

  var app = /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_context.ContextProvider, {
    config: config
  }, /*#__PURE__*/_react.default.createElement(s.AppContainer, null, /*#__PURE__*/_react.default.createElement(s.PageContainer, null, /*#__PURE__*/_react.default.createElement(_basis.Container, {
    bg: theme.bgColor
  }, children)))));

  if (!hasBasisProvider) {
    return /*#__PURE__*/_react.default.createElement(_basis.BasisProvider, {
      theme: _basis.defaultTheme
    }, app);
  }

  return app;
};

exports.AppProvider = AppProvider;

var App = function App(props) {
  var config = props.config,
      environment = props.environment;
  var invalidConfigMessages = (0, _utils.checkConfig)(config);
  (0, _useDatadog.useDatadog)();
  (0, _env.environment)(environment);
  return /*#__PURE__*/_react.default.createElement(_ErrorBoundary.ErrorBoundary, {
    onEvent: config.onEvent
  }, /*#__PURE__*/_react.default.createElement(AppProvider, {
    config: config
  }, invalidConfigMessages.length ? /*#__PURE__*/_react.default.createElement(_components.ConfigErrorMessage, {
    errorMessages: invalidConfigMessages,
    isProduction: (0, _env.environment)() === 'production'
  }) : /*#__PURE__*/_react.default.createElement(_Router.Router, null)));
};

var _default = App;
exports.default = _default;